import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import { useField } from "formik";

export type FormCheckboxProps = CheckboxProps & {
  name: string;
  label: string;
  fullWidth?: boolean;
  margin?: "dense" | "none";
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
};

export default function FormCheckbox({
  fullWidth = true,
  margin = "dense",
  label,
  name,
  ...props
}: FormCheckboxProps): JSX.Element {
  const [field, meta, helpers] = useField(name);
  const { value: checked } = field;

  const errorText = meta.error && meta.touched ? meta.error : "";
  const hasError = !!errorText;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    value: boolean
  ) => {
    helpers.setValue(value);
    if (props.onChange) {
      props.onChange(e, value);
    }
  };
  return (
    <FormControl fullWidth={fullWidth} margin={margin} error={hasError}>
      <FormControlLabel
        control={
          <Checkbox
            {...field}
            checked={checked}
            {...props}
            onChange={handleChange}
          />
        }
        label={label}
      ></FormControlLabel>
      <FormHelperText>{errorText}</FormHelperText>
    </FormControl>
  );
}
